<template>
  <div>
    <pp-container
      :class="mainHeaderClasses"
    >
      <pp-row
        class="no-gutters d-flex"
        :class="isMobile? 'primary': ''"
      >
        <pp-col
          v-if="isMobile"
          cols="2"
          sm="1"
          class="d-flex"
        >
          <pp-button
            v-if="showArrowBackButton"
            type="icon"
            icon="arrow--back"
            aria-label="Back"
            role="button"
            class="pl-2 arrow-back ma-auto"
            data-cy-id="header-arrow-back"
            @click="goBack"
          />
        </pp-col>
        <pp-col>
          <h1
            id="calendar-title"
            aria-live="polite"
            :class="isMobile ? 'px-0 py-2 mx-n4 white--text' : 'pb-0 grey--text text--darken-4 pl-5'"
            class="d-block pa-3 pt-2 text-h4 text-sm-h2 text-center text-sm-left page-header__title"
          >
            {{ title }}
          </h1>
        </pp-col>
        <pp-col
          cols="2"
          sm="1"
          class="d-flex"
        >
          <pp-button
            type="icon"
            icon="close"
            aria-label="Dismiss modal"
            role="button"
            class="close-button ma-auto"
            @click="closeModal"
          />
        </pp-col>
      </pp-row>
    </pp-container>
    <section
      v-if="showAppointmentInfo"
      :class="[
        isMobile ? 'pt-2' : 'pt-4 px-5'
      ]"
    >
      <pp-container class="my-0 py-0 pl-2">
        <pp-avatar-info
          v-if="formData.calendarId"
          :specialty="providerSpecialty"
          :image="providerImage"
          :justify-center="true"
          :name="calendarName"
          :size="isMobile ? 'lg' : 'xl'"
          class="my-0 py-0"
        >
          <template #name>
            <div class="page-header__provider ml-n1 mr-n3 text-body-2 grey--text text--darken-2">
              {{ calendarName }}
            </div>
          </template>
          <template #content>
            <div
              class="page-header__appointment mb-0 ml-n1 mr-n3 text-body-1 grey--text text--darken-4"
            >
              {{ appointmentDate }}
            </div>
          </template>
        </pp-avatar-info>
      </pp-container>
      <pp-divider
        :class="[
          isMobile? 'mt-2 mx-0': 'mt-6 mx-n5'
        ]"
      />
    </section>
    <slot name="additionContent" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { closeModal } from 'sdk-widget-manager'
import * as uiTypes from '@/store/ui/mutations-types'
import { REFERRER_CLOSE_BUTTON } from '@/views/constants'

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    },
    showAppointmentInfo: {
      type: Boolean,
      default: true
    },
    hideBackButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMobile: this.$ppUi.isMobile
    }
  },
  computed: {
    ...mapState('legacy', ['calendars']),
    ...mapGetters({
      formData: 'formData/formData'
    }),
    calendar () {
      return this.calendars[this.formData.calendarIndex]
    },
    calendarName () {
      // try to show providerName if it's empty show calendar Name
      return this.calendar.displayInfo.name
    },
    providerImage () {
      return this.calendar.displayInfo.image
    },
    providerSpecialty () {
      return this.calendar.displayInfo.specialty
    },
    appointmentDate () {
      const date = new Date(`${this.formData.timeBlock.date}T23:59:59`)
      return `${date.toLocaleDateString(
        'en-us',
        {
          weekday: 'long',
          day: 'numeric',
          month: 'short'
        }
      )} - ${this.formData.timeBlock.formattedStartTime}`
    },
    showArrowBackButton () {
      return this.isMobile && !this.hideBackButton
    },
    mainHeaderClasses () {
      const list = []
      if (this.isMobile) {
        list.push('pa-0')
        return list
      }

      if (this.large) {
        list.push('pt-8 pb-0')
      } else {
        list.push('pt-4 pb-1')
      }
      return list
    }
  },
  watch: {
    title: {
      handler () {
        this.onWindowResize()
      }
    }
  },
  mounted () {
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize)
  },
  methods: {
    ...mapActions({
      resetFormData: 'formData/resetFormData',
      resetCreatedAppointment: 'legacy/resetCreatedAppointment'
    }),
    closeModal () {
      this.trackEvent({
        action: 'close_modal',
        label: this.$route.name
      })
      if (this.$useWidgetManager) {
        closeModal()
      } else {
        window.parent.postMessage({ eventType: 'bookclose' }, this.$originHost)
        this.resetFormData()
        this.resetCreatedAppointment()
        if (this.$route.name !== 'stepA') {
          this.$router.replace({ name: 'stepA', params: { referrer: REFERRER_CLOSE_BUTTON }, query: this.$route.query || {} })
        }
      }
    },
    goBack () {
      this.$emit('back-cta-click')
    },
    onWindowResize () {
      setTimeout(() => {
        this.$store.commit(`ui/${uiTypes.SET_HEADER_HEIGHT}`, this.$el.clientHeight)
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  &__provider {
    order: 1;
  }

  &__title {
    @include desktop() {
      line-height: calc-rem(28px);
    }
  }
}

.arrow-back {
  @include mobile() {
    --active-icon: white;
  }
}

.close-button {
  @include mobile() {
    --active-icon: white;
  }
}
</style>
